import React from "react";
import { DataTable } from "@MASTER";
import useLogics from "./logics";
import { ReportEndpoints } from "@REPORTS";
import { useGET } from "@API2";

const Table = ({ filters }) => {
  const logics = useLogics();

  const { data, loading, mutate } = useGET(
    `${ReportEndpoints.deliverySearch}?`,
    new URLSearchParams(filters).toString()
  );

  return (
    <div style={{ width: "calc(100vw - 400px)" }}>
      <DataTable
        name="Gönderi Sorgulama"
        {...logics}
        dataSource={data?.rows || []}
        rowKey="barcode"
        loading={loading}
        pagination={{ pageSize: 15 }}
        scroll={{ x: "max-content" }}
        bordered
        mutate={mutate}
        sticky={{ offsetHeader: 0, offsetScroll: 0 }}
      />
    </div>
  );
};

export default Table;
